import React from "react";
import { Link } from "react-router-dom";
import IRAM from "../assets/images/sidom/fotos/sellos web.png";
import iso9001 from "../assets/images/sidom/fotos/iso9001.png";
import calidadpdf from "../assets/others/politicas-calidad.pdf";

import logo from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";

import { FiLinkedin, FiInstagram } from "../assets/icons/vander";
import { Link as ScrollLink } from "react-scroll";

export default function Footer() {
  return (
    <footer className="relative bg-sidom-blue overflow-hidden">
      <div className="mt-[100px] px-2 md:px-1 lg:px-[40px] container mx-auto ">
        <div className="flex flex-col  lg:flex-row lg:items-start  lg:justify-between gap-8 md:gap-5">
          {/* Columna de Logo e IRAM (Izquierda) */}
          <div className="flex flex-col justify-between items-center gap-12 md:gap-[60px] w-full h-full lg:w-1/4">
            {/* Logo SIDOM (Arriba) */}
            <div className="flex justify-center h-full w-full">
              <Link
                to="/"
                // Se mantiene el max-w para controlar el tamaño absoluto, pero el w-full asegura que use el espacio disponible
                // Elimino los w-[80%] md:w-[80%] ya que w-full es más flexible dentro de este max-w
                className="flex focus:outline-none w-full max-w-[350px]"
              >
                <img
                  src={logo}
                  className="inline-block w-full"
                  alt="SIDOM logo"
                />
              </Link>
            </div>

            {/* IRAM (Abajo) */}
            {/* Se usa "justify-end" en el contenedor para pegarlo a la parte inferior del flex-col padre */}
            <div className="flex flex-col justify-center gap-4 items-center h-full w-full mt-auto">
              <img
                src={IRAM}
                // Se ajusta el max-w para que IRAM tenga un tamaño similar al logo SIDOM
                // Elimino los w-[80%] md:w-[80%] por las mismas razones que el logo SIDOM
                className="inline-block w-full max-w-[250px]"
                alt="IRAM logo"
              />
              <img
                src={iso9001}
                className="inline-block w-full max-w-[250px]"
                alt="ISO 9001 logo"
              />
            </div>
          </div>

          {/* Columna de Servicios, Nosotros, Contacto (Derecha) */}
          <div className="flex flex-col md:flex-row lg:flex-row gap-4  justify-end md:justify-center md:gap-8 lg:gap-12 w-full lg:w-3/4 mt-8 lg:mt-0">
            {/* Servicios */}
            <div className="flex flex-col gap-2 text-sidom-light text-left min-w-[120px] md:min-w-[150px]">
              <h1 className="text-lg font-bold">Servicios</h1>
              <ScrollLink
                to="section-two"
                smooth={true}
                duration={400}
                className="hover:text-sidom-orange cursor-pointer"
              >
                Global Trade
              </ScrollLink>
              <Link
                to="/sidom-smart-reader"
                className="hover:text-sidom-orange"
              >
                SIDOM Smart Reader
              </Link>
              <Link to="/sidom-insurance" className="hover:text-sidom-orange">
                SIDOM Insurance
              </Link>
              <Link to="/pay" className="hover:text-sidom-orange">
                SIDOM Pay
              </Link>
              <Link to="/sidom-mre" className="hover:text-sidom-orange">
                SIDOM MRE
              </Link>
              <Link to="/sidom-misim" className="hover:text-sidom-orange">
                SIDOM MiSIM
              </Link>
            </div>

            {/* Nosotros */}
            <div className="flex flex-col gap-2 text-sidom-light text-left min-w-[120px] md:min-w-[150px]">
              <h1 className="text-lg font-bold">Nosotros</h1>
              <Link to="/about" className="hover:text-sidom-orange">
                Sobre nosotros
              </Link>
              <Link
                to="/politicas-de-privacidad"
                className="hover:text-sidom-orange"
              >
                Políticas de privacidad
              </Link>
              <a
                href={calidadpdf}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sidom-orange"
              >
                Política de Gestión de la Calidad
              </a>
              <a
                href="https://atencion.sidom.io/support/login?__hstc=225037893.bf6afd0faaabac1c77500320d4a80f00.1747164551158.1748618928409.1748630588818.11&__hssc=225037893.16.1748630588818&__hsfp=611053511"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sidom-orange"
              >
                Soporte
              </a>
            </div>

            {/* Contacto */}
            <div className="flex flex-col gap-2 text-sidom-light text-left min-w-[240px] max-w-[300px]">
              <h1 className="text-lg font-bold">Contacto</h1>
              <p>
                Camila O’Gorman 412,
                <br /> Puerto Madero,
                <br /> ARGENTINA
              </p>
              <p>
                Ruta 8 Km. 17.500, Edificio @3 <br /> Of. 104, Zonamérica,
                Montevideo,
                <br /> URUGUAY
              </p>
              <a
                href="tel:+5491137241700"
                className="hover:text-sidom-orange text-nowrap block"
              >
                Teléfono: +54 11 3724 1700
              </a>
              <a
                href="mailto:comercial@sidom.io"
                className="hover:text-sidom-orange text-nowrap block"
              >
                comercial@sidom.io
              </a>
              <ul className="list-none text-start flex gap-4 mt-3">
                <li>
                  <a
                    href="https://instagram.com/sidomsuite"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-sidom-blue hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white transition-colors duration-300"
                  >
                    <FiInstagram className="h-[18px] w-[18px]" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/sidomgt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-9 w-9 inline-flex items-center justify-center rounded-full bg-sidom-blue hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white transition-colors duration-300"
                  >
                    <FiLinkedin className="h-[18px] w-[18px]" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright e íconos de certificación  */}
        <div className="mt-4  border-t border-sidom-light/20 flex flex-col md:flex-row justify-center items-center text-center md:text-left gap-4">
          <div className="flex flex-row gap-4 justify-center md:justify-start"></div>
          <p className="text-sidom-light text-center text-sm">
            Copyright © {new Date().getFullYear()} SIDOM.
          </p>
        </div>
      </div>
    </footer>
  );
}
